import { render, staticRenderFns } from "./CoursesView.vue?vue&type=template&id=ae8cc4a8"
import script from "./CoursesView.vue?vue&type=script&lang=js"
export * from "./CoursesView.vue?vue&type=script&lang=js"
import style0 from "./CoursesView.vue?vue&type=style&index=0&id=ae8cc4a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports